/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface EmailLinkMethodOptions
 */
export interface EmailLinkMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof EmailLinkMethodOptions
     */
    method: FactorMethod;
    /**
     * URI to redirect to after resolving the challenge.
     * @type {string}
     * @memberof EmailLinkMethodOptions
     */
    redirect_target?: string;
}



/**
 * Check if a given object implements the EmailLinkMethodOptions interface.
 */
export function instanceOfEmailLinkMethodOptions(value: object): value is EmailLinkMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function EmailLinkMethodOptionsFromJSON(json: any): EmailLinkMethodOptions {
    return EmailLinkMethodOptionsFromJSONTyped(json, false);
}

export function EmailLinkMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailLinkMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
        'redirect_target': json['redirect_target'] == null ? undefined : json['redirect_target'],
    };
}

export function EmailLinkMethodOptionsToJSON(json: any): EmailLinkMethodOptions {
    return EmailLinkMethodOptionsToJSONTyped(json, false);
}

export function EmailLinkMethodOptionsToJSONTyped(value?: EmailLinkMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
        'redirect_target': value['redirect_target'],
    };
}

